export * from "ce/pages/AppIDE/layout/components/Header/useLibraryHeaderTitle";
import { default as CE_useLibraryHeaderTitle } from "ce/pages/AppIDE/layout/components/Header/useLibraryHeaderTitle";

export default CE_useLibraryHeaderTitle;
